// В.2.d-3: интеграция keyword `posthumous_contract` в путь смерти юнита.
//
// Регистрируем extra-handler через registerOnUnitDiedExtraHandler.
// Порядок вызовов в onUnitDied:
//   1. Стандартные deathrattles (Аналитик, Дредноут, Бот опергруппы, Моды).
//   2. Пересчёты (Аура директора, Цепь, line-triggers).
//   3. fireOnUnitDiedExtras → Donor → Реаниматор → ... → Posthumous Contract.
// Так что Реаниматор и другие триггеры on_unit_died отрабатывают ДО
// воскрешения — это и хочет диздок: «сначала смерть со всеми эффектами,
// потом воскрешение».
//
// Импортируется ПОСЛЕ reanimator.js в livlife/index.js — чтобы быть
// зарегистрированным позже и сработать в конце.

import { registerOnUnitDiedExtraHandler } from '../deus/hooks.js';
import { triggerPosthumousContractOnDeath } from '../../keywords/posthumous_contract.js';

registerOnUnitDiedExtraHandler((state, payload) => {
  const card = payload?.card;
  if (!card) return;
  // Спящий агент у врага — отдельный сценарий, контракт не работает.
  if (card.sleeperState != null) return;
  triggerPosthumousContractOnDeath(state, card, payload.ownerIdx);
});
